<template>
    <div class="row mt-4">
        <div class="col-12 col-lg-2 col-md-2 col-xs-2">
            <div class="block-content block-content-full px-3 py-3 mb-0 campaing-left-block">
                <button
                    class="btn btn-primary campaing-left-block-btn-primary-add btn-plr-15 fs-xs fw-medium rounded-8 h-40"
                    @click="goToCreateCampaign()"
                >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                <hr class="hr-left-block" />
                <button
                    class="btn campaing-left-block-btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40"
                    :class="status === 'ALL' ? 'btn-primary-inverse' : 'btn-primary-muted'"
                    @click="changeStatus('ALL')"
                >
                    {{ $t('marketing.campaigns.status.all') }}
                </button>
                <button
                    class="btn campaing-left-block-btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :class="status === 'IN_PROGRESS' ? 'btn-primary-inverse' : 'btn-primary-muted'"
                    @click="changeStatus('IN_PROGRESS')"
                >
                    {{ $t('marketing.campaigns.status.scheduled') }}
                </button>
                <button
                    class="btn campaing-left-block-btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :class="status === 'SCHEDULE' ? 'btn-primary-inverse' : 'btn-primary-muted'"
                    @click="changeStatus('SCHEDULE')"
                >
                    {{ $t('marketing.campaigns.status.scheduled') }}
                </button>
                <button
                    class="btn campaing-left-block-btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :class="status === 'DRAFT' ? 'btn-primary-inverse' : 'btn-primary-muted'"
                    @click="changeStatus('DRAFT')"
                >
                    {{ $t('marketing.campaigns.status.draft') }}
                </button>
                <button
                    class="btn campaing-left-block-btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :class="status === 'FINISHED' ? 'btn-primary-inverse' : 'btn-primary-muted'"
                    @click="changeStatus('FINISHED')"
                >
                    {{ $t('marketing.campaigns.status.finished') }}
                </button>
            </div>
        </div>

        <div class="col-12 col-lg-10 col-md-10 col-xs-10">
            <div class="row">
                <div class="col-12 col-lg-12 col-md-12 col-xs-12">
                    <div class="form-control rounded-15 height48 input-group" style="padding: 0.5rem">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-white border-0" style="padding-top: 0.6rem">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    style="margin-top: -3px"
                                >
                                    <path
                                        d="M8.75002 15.8334C12.6621 15.8334 15.8334 12.6622 15.8334 8.75008C15.8334 4.838 12.6621 1.66675 8.75002 1.66675C4.83794 1.66675 1.66669 4.838 1.66669 8.75008C1.66669 12.6622 4.83794 15.8334 8.75002 15.8334Z"
                                        stroke="#94A3B8"
                                        stroke-width="1.5"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path
                                        d="M11.1071 5.97625C10.7979 5.66627 10.4305 5.42044 10.026 5.2529C9.62149 5.08536 9.18786 4.99942 8.75003 5C8.3122 4.99942 7.87857 5.08536 7.47406 5.2529C7.06955 5.42044 6.70214 5.66627 6.39294 5.97625M13.8425 13.8425L17.3779 17.3779"
                                        stroke="#94A3B8"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                </svg>
                            </span>
                        </div>
                        <input
                            id="search"
                            ref="searchInput"
                            class="form-control-search"
                            :placeholder="$t('common.search')"
                            v-model="search"
                            @input="handleSearch"
                            style="width: 85%"
                        />
                    </div>
                </div>
                <!-- <div class="col-12 col-lg-4 col-md-4 col-xs-4">
                    <input class="form-control rounded-12 height48" disabled="true" :placeholder="$t('marketing.campaigns.last_modification')" />
                </div> -->
            </div>

            <div
                v-if="campaigneEmailsList && campaigneEmailsList.length > 0"
                class="block-content block-content-full px-4 py-45 mb-0 mt-3"
            >
                <div v-if="loading" class="loader-container">
                    <div class="loader"></div>
                </div>

                <div class="pagination-section pb-4">
                    <button class="btn-pagination ms-2" @click="gotoPage(1)" :disabled="currentPage === 1">&laquo;</button>
                    <button class="btn-pagination ms-2" @click="gotoPage(currentPage - 1)" :disabled="currentPage === 1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 320 512">
                            <path
                                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
                            />
                        </svg>
                    </button>
                    <button class="currentPage ms-2">{{ currentPage }}</button>
                    <button class="btn-pagination ms-2" @click="gotoPage(currentPage + 1)" :disabled="currentPage === totalPages">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 320 512">
                            <path
                                d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                            />
                        </svg>
                    </button>
                    <button class="btn-pagination fs-6 ms-2" @click="gotoPage(totalPages)" :disabled="currentPage === totalPages">
                        &raquo;
                    </button>

                    <select
                        class="form-select select-per-page fs-sm p-2 rounded-8 fw-medium ms-2"
                        @change="onPerPageChange"
                        style="float: inline-end"
                    >
                        <option v-for="option in perPageOptions" :key="option" :value="option" @change="">{{ option }}</option>
                    </select>
                </div>

                <table
                    class="table table-striped table-vcenter table-right-block-email w-100"
                    style="min-width: 732px; overflow: auto !important"
                >
                    <tbody>
                        <tr v-for="(item, index) in campaigneEmailsList" :key="index">
                            <td class="fw-normal fs-sm">
                                <!-- <input
                                    type="radio"
                                    :id="'campaign-index-radio' + index"
                                    name="radio-group"
                                    class="form-check-input"
                                    v-model="item.checked"
                                /> -->

                                <i
                                    class="fa fa-check-circle fa-3"
                                    :style="checkGlobalConfig(item).verifed ? 'color: #22bb33' : 'color: #ff9966'"
                                    aria-hidden="true"
                                    :title="generateTitle(checkGlobalConfig(item).array)"
                                ></i>
                                <label :id="'campaign-index-radio' + index"></label>
                                <i class="fa fa-envelope p-2" aria-hidden="true"></i>
                            </td>
                            <td class="fw-normal fs-sm">
                                <div class="row">
                                    <div class="col-6">
                                        <h5 class="right-block-email-object">
                                            {{ item.name ?? $t('marketing.campaigns.untitled') }}
                                        </h5>
                                        <p class="right-block-email-desc">
                                            {{ item.email_subject ?? $t('marketing.campaigns.no_subject') }}
                                        </p>
                                        <p class="right-block-email-date text-muted">
                                            {{ item.start_date }} {{ item.start_time }}
                                        </p>
                                    </div>
                                    <div class="col-6 d-flex align-items-center justify-content-center">
                                        <button class="btn btn-primary-inverse-sm fs-xs fw-medium rounded-8 h-40 mt-1">
                                            {{ getStatusTranslation(item.status) }}
                                        </button>
                                    </div>
                                </div>
                            </td>
                            <td class="fw-normal fs-sm">
                                <div class="dropdown d-inline-block float-end">
                                    <button
                                        type="button"
                                        class="dropdown-button btn-primary-dropdown rounded-8 fs-sm fw-semibold px-3"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="true"
                                        style="height: 30px !important"
                                    >
                                        {{ $t('common.actions') }} <i class="fa fa-angle-down p-1" aria-hidden="true"></i>
                                    </button>
                                    <div
                                        class="dropdown-menu dropdown-action dropdown-menu-end rounded-24 dropdown-variable-menu"
                                    >
                                        <button
                                            class="btn btn-sm btn-action m-1"
                                            @click="goToCreateCampaignAndDuplicate(item.uuid)"
                                        >
                                            {{ $t('marketing.campaigns.actions.duplicate') }}
                                        </button>
                                        <button
                                            class="btn btn-sm btn-action m-1"
                                            :disabled="item.status == 3"
                                            @click="goToCreateCampaign(item.uuid)"
                                        >
                                            {{ $t('marketing.campaigns.actions.edit') }}
                                        </button>
                                        <button
                                            class="btn btn-sm btn-action m-1"
                                            :disabled="isLoadingDestroyBtn || item.status == 3"
                                            @click="destroy(item.uuid)"
                                        >
                                            <span v-if="isLoadingDestroyBtn">
                                                <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                                                <span class="sr-only"> {{ $t('common.loading') }}</span>
                                            </span>
                                            <span v-else> {{ $t('marketing.campaigns.actions.delete') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                v-if="!loading && !campaigneEmailsList.length > 0 && search == '' && status == 'ALL'"
                class="block-content block-content-full px-5 py-5 mb-0 mt-3"
            >
                <h3 class="right-block-title text-center mt-3">{{ $t('marketing.campaigns.empty_state_title') }}</h3>
                <p class="right-block-desc text-center mt-3">{{ $t('marketing.campaigns.empty_state') }}</p>
                <div class="campaing-btn-center">
                    <button
                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-3 text-center"
                        @click="goToCreateCampaign()"
                    >
                        {{ $t('marketing.campaigns.create') }}
                    </button>
                </div>
            </div>

            <div
                v-if="!loading && !campaigneEmailsList.length > 0 && !search == ''"
                class="block-content block-content-full px-5 py-5 mb-0 mt-3"
            >
                <h3 class="right-block-title text-center mt-3">{{ $t('marketing.campaigns.filter_results') }} : {{ search }}</h3>
                <p class="right-block-desc text-center mt-3">{{ $t('marketing.campaigns.no_results') }}</p>
            </div>

            <div
                v-if="!loading && !campaigneEmailsList.length > 0 && status !== 'ALL'"
                class="block-content block-content-full px-5 py-5 mb-0 mt-3"
            >
                <h3 class="right-block-title text-center mt-3">{{ $t('marketing.campaigns.filter_results') }}</h3>
                <p class="right-block-desc text-center mt-3">{{ $t('marketing.campaigns.no_results') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
// v-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ApiManagerMarketing from './Api/ApiManagerMarketing.js'

export default {
    name: 'MarketingCompaignEmailsIndex',
    props: ['url_btn_campaigne_email_create'],
    data: () => ({
        campaigneEmailsList: [],
        loading: false,
        status: 'ALL',
        search: '',
        isLoadingDestroyBtn: false,
        search: '',
        debouncedSearch: null,

        itemsPerPage: 10,
        recordsTotal: 0,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200],
    }),
    computed: {
        totalPages() {
            return Math.ceil(this.recordsTotal / this.itemsPerPage)
        },
    },
    methods: {
        goToCreateCampaign(uuid = '') {
            window.location.href =
                uuid === ''
                    ? this.url_btn_campaigne_email_create
                    : `${this.url_btn_campaigne_email_create}?campaigne_email_uuid=${uuid}`
        },

        goToCreateCampaignAndDuplicate(uuid) {
            window.location.href = `${this.url_btn_campaigne_email_create}?campaigne_email_uuid=${uuid}&is_duplication=true`
        },

        async campaigneEmailsFetch(params) {
            this.loading = true
            try {
                const result = await ApiManagerMarketing.campaigneEmailsFetch(params)
                this.recordsTotal = result?.meta?.total ?? 0
                this.campaigneEmailsList = result?.data ?? []
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },

        gotoPage(page) {
            this.currentPage = page
            this.campaigneEmailsFetch({
                ajax: true,
                status: status,
                search: this.search,
                page: this.currentPage,
                perPage: this.itemsPerPage,
                search: this.search,
            })
        },

        onPerPageChange(event) {
            this.itemsPerPage = event.target.value
            this.campaigneEmailsFetch({
                ajax: true,
                status: this.status,
                page: this.currentPage,
                perPage: this.itemsPerPage,
                search: this.search,
            })
        },

        async destroy(uuid) {
            this.isLoadingDestroyBtn = true
            try {
                const res = await ApiManagerMarketing.destroy(uuid)
                if (res.status == 200) {
                    this.notifySuccess(res?.data?.message ?? this.$t('marketing.messages.saved_success'))
                    this.campaigneEmailsFetch({
                        ajax: true,
                        status: this.status,
                        search: this.search,
                    })
                } else {
                    this.notifyError(res?.message)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.notifyError(error?.response?.data?.message ?? error?.message)
            } finally {
                this.isLoadingDestroyBtn = false
            }
        },

        changeStatus(status) {
            this.search = ''
            this.status = status
            this.currentPage = 1
            this.campaigneEmailsFetch({
                ajax: true,
                status: status,
                search: this.search,
                page: this.currentPage,
                perPage: this.itemsPerPage,
                search: this.search,
            })
        },

        notifyError(message = this.$t('common.error_occurred')) {
            this.$toast.error(message)
        },

        notifySuccess(message = this.$t('marketing.messages.operation_success'), timeout = 3000) {
            this.$toast.success(message)
        },

        handleSearch(event) {
            this.search = event.target.value
            this.debouncedSearch()
        },

        async performSearch() {
            this.campaigneEmailsFetch({
                ajax: true,
                status: this.status,
                search: this.search,
            })
        },

        getStatusTranslation(status) {
            const statusMap = {
                0: 'draft',
                1: 'in_progress',
                2: 'canceled',
                3: 'finished',
                4: 'scheduled',
                5: 'failed',
            }
            const key = statusMap[status] || 'draft'
            return this.$t(`marketing.campaigns.status.${key}`)
        },

        debounce(func, wait) {
            let timeout
            return function (...args) {
                clearTimeout(timeout)
                timeout = setTimeout(() => func.apply(this, args), wait)
            }
        },

        checkGlobalConfig(item) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

            const checks = [
                {
                    key: 'name_sender',
                    name: this.$t('marketing.campaigns.config_checks.instance_name'),
                    invalidValues: ['', undefined, null],
                },
                {
                    key: 'email_sender',
                    name: this.$t('marketing.campaigns.config_checks.marketing_email'),
                    customValidation: (value) => emailRegex.test(value),
                },
                {
                    key: 'email_subject',
                    name: this.$t('marketing.campaigns.config_checks.subject'),
                    invalidValues: ['', undefined, null],
                },
                {
                    key: 'user_custom_filter_id',
                    name: this.$t('marketing.campaigns.config_checks.customer_list'),
                    invalidValues: ['', 0, undefined, null],
                },
                {
                    key: 'confirmed',
                    name: this.$t('marketing.campaigns.config_checks.confirmation'),
                    expectedValue: true,
                    invalidValues: [0, false, undefined, null],
                },
                {
                    key: 'content',
                    name: this.$t('marketing.campaigns.config_checks.content'),
                    invalidValues: ['', undefined, null],
                },
            ]

            const array = []
            let verifed = true

            checks.forEach(
                ({ key, name, invalidValues = [undefined, null, ''], expectedValue = undefined, customValidation }) => {
                    const value = item[key]
                    let isValid

                    if (customValidation) {
                        isValid = customValidation(value)
                    } else if (expectedValue !== undefined) {
                        isValid = value === expectedValue
                    } else {
                        isValid = !invalidValues.includes(value)
                    }

                    array.push({ name, [key]: isValid })

                    if (!isValid) {
                        verifed = false
                    }
                }
            )

            return { array, verifed }
        },
        generateTitle(array) {
            return array.map((entry) => `${Object.values(entry)[1] ? '✅' : '❌'} ${entry.name}`).join('\n')
        },
    },
    async mounted() {
        this.campaigneEmailsFetch({
            ajax: true,
            status: this.status,
            search: this.search,
        })
        this.debouncedSearch = this.debounce(this.performSearch, 300)
    },
    components: {
        vSelect,
    },
}
</script>

<style scoped>
.campaing-btn-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.campaing-left-block {
    height: 100%;
}

.campaing-left-block-btn-primary-add {
    width: 100%;
    text-align: center;
    margin: auto;
}

.campaing-left-block-btn-primary {
    width: 100%;
    text-align: left;
    margin: auto;
}

.btn-primary-muted {
    --bs-text-opacity: 1;
    color: #94a3b8;
}

.right-block-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
}

.right-block-desc {
    font-size: clamp(12px, 0.729545vw, 16px);
    font-weight: 400;
    line-height: 28px;
}

.right-block-email-object,
.right-block-email-desc,
.right-block-email-date {
    margin: 0;
    font-size: clamp(12px, 0.729545vw, 16px);
    font-weight: 400;
    line-height: 21px;
}

.right-block-email-object {
    color: #7d2dbd;
    font-size: 15px;
}

.table-right-block-email tr {
    border-top: 1px solid #7b82894d;
}

.btn-primary-inverse-sm {
    color: #7d2dbd;
    background-color: #fff;
    border-color: #7d2dbd;
    height: 25px !important;
    border-radius: 24px;
    padding: 0 1rem !important;
}

.btn-primary-dropdown {
    color: #fff;
    background-color: #7d2dbd;
    border-color: #7d2dbd;
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 16px !important;
}

.hr-left-block {
    border: 1px solid rgba(123, 130, 137, 0.3);
    box-shadow: 0px 3px 40px 0px rgba(0, 0, 0, 0.05);
}

.form-control-search {
    border-color: white;
    outline: none;
    box-shadow: none;
}

.loader-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.loader {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #333;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.select-per-page {
    height: 40px !important;
    line-height: 25px !important;
    max-width: 75px;
    display: inline;
}
</style>
